import { FC } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { rootPaths } from "pages/routes";
import { signin } from "../../service/signin";

type Inputs = {
  userId: string;
  password: string;
};

const SigninPage: FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ userId: string; password: string }>({
    mode: "onSubmit",
    reValidateMode: "onChange",
    defaultValues: {
      userId: "",
      password: "",
    },
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
  });
  let location = useLocation();
  const navigate = useNavigate();

  // fromはサインインできなかった際の元々踏もうとしてたURL
  const to = location.state?.from?.pathname || rootPaths.selectBranch;

  const onSubmit: SubmitHandler<Inputs> = async (data: {
    userId: string;
    password: string;
  }) => {
    // email,passwardのサンプル
    // email: oAhyajnecUnphMdSl3eg@recopo.info password: bGnGumDXRyLfGZOpLg7Y(develop, recopo水戸店)
    const errorMessage = await signin(data.userId, data.password);
    if (!errorMessage) {
      navigate(to);
    } else {
      alert(errorMessage);
    }
  };

  return (
    <main>
      <div className="card">
        <div className="card-header">
          <p className="card-header-title is-centered">ログイン</p>
        </div>
        <div className="card-content">
          <form className="m-3" onSubmit={handleSubmit(onSubmit)}>
            <div className="columns is-mobile p-2">
              <label className="column is-2-desktop is-offset-2-desktop label">
                店舗ID：
              </label>
              <input
                className="column  is-4-desktop is-padding-2 input"
                type="text"
                placeholder="店舗ID"
                {...register("userId", { required: true })}
              />
              {errors.userId && <span>This field is required</span>}
            </div>
            <div className="columns is-mobile p-2">
              <label className="column is-2-desktop is-offset-2-desktop label">
                パスワード：
              </label>
              <input
                className="column is-4-desktop is-padding-2 input"
                type="password"
                placeholder="Password"
                {...register("password", { required: true })}
              />
              {errors.password && <span>This field is required</span>}
            </div>
            <div className="columns is-centered mt-6">
              <button className="column button is-2 p-0">
                <span className="">ログイン</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
};

export default SigninPage;
